<template>
    <div class="booth-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item><i class="el-icon-s-shop"></i>展位列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-s-data"></i>
                    <span>展位信息管理</span>
                </div>
                <div class="header-actions">
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addData">
                        新增展位
                    </el-button>
                    <el-button size="mini" icon="el-icon-s-grid" @click="goCategory">
                        分类管理
                    </el-button>
                </div>
            </div>

            <!-- 搜索区域 -->
            <div class="search-container">
                <el-form
                        :inline="true"
                        :model="searchForm"
                        ref="searchForRef"
                        label-width="80px"
                        size="mini"
                        class="search-form"
                >
                    <el-form-item label="所属展会">
                        <el-select
                                v-model="searchForm.exhibition_id"
                                placeholder="请选择展会"
                                clearable
                                filterable
                                style="width: 200px"
                        >
                            <el-option
                                    v-for="item in exhibitionList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="所属展馆">
                        <el-select
                                v-model="searchForm.venue_id"
                                placeholder="请选择展馆"
                                clearable
                                filterable
                                style="width: 200px"
                        >
                            <el-option
                                    v-for="item in venueList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="展位名称">
                        <el-input
                                v-model="searchForm.name"
                                placeholder="请输入展位名称"
                                clearable
                                prefix-icon="el-icon-search"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="展位状态">
                        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="可预订" value="1"></el-option>
                            <el-option label="已预订" value="2"></el-option>
                            <el-option label="已售出" value="3"></el-option>
                            <el-option label="不可用" value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button size="mini" type="primary" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 数据表格 -->
            <div class="table-container">
                <el-table
                        ref="multipleTable"
                        :data="tableLoadData"
                        stripe
                        border
                        size="mini"
                        v-loading="loading"
                        element-loading-text="数据加载中..."
                        element-loading-spinner="el-icon-loading"
                        :empty-text="emptyText"
                        style="width: 100%"
                >
                    <el-table-column type="index" label="序号" width="70" align="center">
                        <template slot-scope="scope">
                            <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展位名称"
                            width="300"
                            prop="title"
                            :show-overflow-tooltip='true'
                    >
<!--                        <template slot-scope="scope">-->
<!--                            <div class="booth-name-cell">-->
<!--                                <div class="booth-name">{{ scope.row.title }}</div>-->
<!--                                <div class="booth-number" v-if="scope.row.booth_number">-->
<!--                                    <el-tag size="mini" type="info">编号: {{ scope.row.booth_number }}</el-tag>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </template>-->
                    </el-table-column>

                    <el-table-column
                            label="所属展会"
                            width="200"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.exhibition" class="exhibition-info">
                                <div class="exhibition-name">{{ scope.row.exhibition.title }}</div>
                                <div class="exhibition-time" v-if="scope.row.exhibition.start_time">
                                    {{ scope.row.exhibition.start_time | dateFormat }}
                                </div>
                            </div>
                            <span v-else class="empty-text">未分配</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="所属展馆"
                            width="180"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.venue" class="venue-info">
                                <div class="venue-name">{{ scope.row.venue.title }}</div>
                                <div class="venue-area" v-if="scope.row.venue.area">
                                    <el-tag size="mini">{{ scope.row.venue.area }}㎡</el-tag>
                                </div>
                            </div>
                            <span v-else class="empty-text">未分配</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展位状态"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-tag
                                    v-if="scope.row.status === 1"
                                    size="mini"
                                    type="success"
                                    effect="dark"
                            >可预订</el-tag>
                            <el-tag
                                    v-else-if="scope.row.status === 2"
                                    size="mini"
                                    type="warning"
                                    effect="dark"
                            >已预订</el-tag>
                            <el-tag
                                    v-else-if="scope.row.status === 3"
                                    size="mini"
                                    type="danger"
                                    effect="dark"
                            >已售出</el-tag>
                            <el-tag
                                    v-else
                                    size="mini"
                                    type="info"
                                    effect="dark"
                            >不可用</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展位面积"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.area">{{ scope.row.area }}㎡</span>
                            <span v-else class="empty-text">-</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展位价格"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.price">¥{{ scope.row.price }}</span>
                            <span v-else class="empty-text">-</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="所属分类"
                            width="150"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-tag size="mini" type="primary" v-if="scope.row.category">
                                {{ scope.row.category.name }}
                            </el-tag>
                            <span v-else class="empty-text">未分类</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="添加日期"
                            width="180"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.add_time | dateFormat }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="操作"
                            width="180"
                            fixed="right"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div class="action-buttons">
                                <el-button
                                        type="text"
                                        icon="el-icon-edit"
                                        size="mini"
                                        @click="handleClick(scope.row)"
                                >编辑</el-button>
                                <el-button
                                        type="text"
                                        icon="el-icon-delete"
                                        size="mini"
                                        @click="del(scope.row)"
                                >删除</el-button>
                                <el-button
                                        type="text"
                                        icon="el-icon-delete"
                                        size="mini"
                                        @click="goInfo(scope.row)"
                                >详情</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                >
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    import moment from 'moment'
    import axios from "axios";
    export default {
        name: "BoothList",
        components: {},
        props: {},
        data() {
            return {
                areaList:[],
                isResouceone: false,
                propsdata: {
                    checkStrictly: true,
                    lazy: true,
                    lazyLoad(node, resolve) {
                        console.log(node)
                        let url= '/api/api/cmp.sys.Region_read_lz/findRegionList';
                        setTimeout(() => {
                            if (node.level == 0) {
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:1
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                            if (node.level == 1) {
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:node.value
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                            if (node.level == 2) {
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:node.value
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                            leaf: true,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                        }, 100);
                    },
                },
                // 展会列表
                exhibitionList: [],
                // 展馆列表
                venueList: [],

                // 搜索表单
                searchForm: {
                    name: "",
                    exhibition_id: "",
                    venue_id: "",
                    status: "",
                    shop_id: '',
                    keyword: '',
                },
                // 表格数据
                tableLoadData: [],
                loading: false,
                emptyText: "暂无数据",

                // 分页
                pageNum: 1,
                pageSize: 10,
                total: 0,

                showType: '',
            };
        },
        created() {
            this.showType = this.$route.query.showType;
            this.DataList();
          //  this.getExhibitionList();
            this.getVenueList();
        },
        filters: {
            // 时间格式化
            dateFormat(add_time) {
                if (!add_time) return "";
                return moment(add_time * 1000).format("YYYY-MM-DD");
            }
        },
        methods: {
            // 获取展会列表
            getExhibitionList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: 1,
                    pageSize: 1000 // 获取足够多的展会数据
                }

                this.$axios.findExpoListP(param).then(res => {
                    if (res.code == 200) {
                        this.exhibitionList = res.data.data || [];
                    }
                }).catch(error => {
                    console.log(error);
                })
            },

            // 获取展馆列表
            getVenueList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: 1,
                    pageSize: 1000 // 获取足够多的展馆数据
                }

                this.$axios.findVenueListP(param).then(res => {
                    if (res.code == 200) {
                        this.venueList = res.data.data || [];
                    }
                }).catch(error => {
                    console.log(error);
                })
            },

            // 跳转到编辑页面
            handleClick(row) {

                this.$router.push({
                    name:"boothForm",
                    query:{
                        expo_id:row.id
                    }});

           
            },

            // 跳转到分类管理
            goCategory() {
                this.$router.push('/boothCategory')
            },

            // 获取展位列表
            DataList() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    showType: this.showType,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    parent_id: sessionStorage.getItem('shop_id'),
                    proxy_id: sessionStorage.getItem('proxy_id'),
                    title: this.searchForm.name,
                    status: this.searchForm.status,
                    exhibition_id: this.searchForm.exhibition_id,
                    venue_id: this.searchForm.venue_id
                }

                // 使用展位列表接口
                this.$axios.findExpoListP(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.tableLoadData = res.data.data || [];
                        this.total = res.data.total || 0;

                        // 如果没有数据，显示提示信息
                        if (this.tableLoadData.length === 0) {
                            this.emptyText = "暂无展位数据";
                        }
                    } else {
                        this.$message.error(res.msg || "获取数据失败");
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error("网络错误，请稍后重试");
                })
            },

            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize;
                this.pageNum = 1;
                this.DataList();
            },

            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage;
                this.DataList();
            },
            goInfo(row){
                this.$router.push({
                    name:"boothInfo",
                    query:{
                        id:row.id
                    }});
            },
            // 新增展位
            addData() {
                this.$router.push('/boothForm');
            },

            // 搜索
            searchSubmit() {
                this.pageNum = 1;
                this.DataList();
            },

            // 重置搜索
            resetSearch() {
                this.searchForm = {
                    name: "",
                    exhibition_id: "",
                    venue_id: "",
                    status: ""
                };
                this.pageNum = 1;
                this.DataList();
            },

            // 删除展位
            del(e) {
                this.$confirm('确定要删除该展位吗？', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id: sessionStorage.getItem('company_id'),
                        access_token: sessionStorage.getItem('token'),
                        id: e.id,
                    }

                    // 使用展位删除接口
                    this.$axios.boothDel(param).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.pageNum = 1;
                            this.DataList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                        this.$message.error("删除失败，请稍后重试");
                    });
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
            }
        }
    };
</script>

<style scoped>
    .booth-container {
        padding: 20px;
        background-color: #f5f7fa;
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 8px;
        border: none;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 20px;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .header-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .search-container {
        margin-bottom: 20px;
    }

    .search-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .table-container {
        margin-bottom: 20px;
    }

    .booth-name-cell {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .booth-name {
        font-weight: 500;
        margin-bottom: 4px;
    }

    .booth-number {
        margin-top: 2px;
    }

    .exhibition-info, .venue-info {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .exhibition-name, .venue-name {
        font-weight: 500;
        margin-bottom: 4px;
    }

    .exhibition-time, .venue-area {
        font-size: 12px;
        color: #909399;
    }

    .empty-text {
        color: #909399;
        font-style: italic;
    }

    .action-buttons {
        display: flex;
        justify-content: center;
        gap: 8px;
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .booth-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .header-actions {
            margin-top: 10px;
        }

        .search-form {
            flex-direction: column;
            align-items: flex-start;
        }

        .search-form .el-form-item {
            margin-right: 0;
            margin-bottom: 10px;
            width: 100%;
        }

        .action-buttons {
            flex-direction: column;
            gap: 5px;
        }

        .action-buttons .el-button {
            width: 100%;
        }
    }
</style>
